import { useTranslation } from 'react-i18next';

export default function TrustBar() {
  const { t } = useTranslation();

  const trustPoints = [
    { icon: 'ri-map-pin-2-line', title: t('trust.t1.title'), desc: t('trust.t1.desc') },
    { icon: 'ri-group-line', title: t('trust.t2.title'), desc: t('trust.t2.desc') },
    { icon: 'ri-links-line', title: t('trust.t3.title'), desc: t('trust.t3.desc') },
    { icon: 'ri-calendar-check-line', title: t('trust.t4.title'), desc: t('trust.t4.desc') },
  ];

  return (
    <section className="bg-blue-600 py-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-blue-500">
          {trustPoints.map((point) => (
            <div key={point.title} className="flex items-start gap-4 px-6 py-6">
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className={`${point.icon} text-blue-200 text-xl`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-white leading-tight">{point.title}</p>
                <p className="text-xs text-blue-200 mt-0.5 leading-relaxed">{point.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
